import React, { useState } from "react";
import { convertPrice } from "../../../../../../helpers/price";

const CartListingCart = ({ cartimage, cartquantity, cartname, cartprice }) => {
  const truncatedText = (text) => {
    const words = text.split("");
    if (words.length > 25) {
      return words.slice(0, 15).join("") + "...";
    }

    return text;
  };
  return (
    <div className="cart_group">
      <div className="container">
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={cartimage}
            alt={cartname}
            style={{
              width: "50px",
              height: "50px",
              marginRight: "15px",
              borderRadius: "8px",
            }}
          />

          <div className="cart-detail">
            <h4 className="cart-name" style={{ fontSize: "13px" }}>
              {truncatedText(cartname)}
            </h4>
            <h5
              className="cart-quantity"
              style={{ fontSize: "10px", fontWeight: "600" }}
            >
              x {cartquantity}
            </h5>
          </div>
        </div>
        <div className="cart-footer">
          <h4 className="cart-price" style={{ fontSize: "13px" }}>
            MYR {convertPrice(cartprice)}
          </h4>
        </div>
      </div>
    </div>
  );
};

export default CartListingCart;
